import { defineMessages } from 'react-intl';

export const amenitiesMessages = defineMessages({
  title: {
    id: 'venue-page.amenities.title',
    defaultMessage: 'Amenities',
  },
  explanation: {
    id: 'venue-page.amenities.explanation',
    defaultMessage: 'Help users know what to expect at your facilities.',
  },
  childcare: {
    id: 'venue-page.amenities.childcare',
    defaultMessage: 'Childcare',
  },
  foodBeverages: {
    id: 'venue-page.amenities.food-beverages',
    defaultMessage: 'Food/Beverages',
  },
  hairdryer: {
    id: 'venue-page.amenities.hairdryer',
    defaultMessage: 'Hairdryer',
  },
  lockers: {
    id: 'venue-page.amenities.lockers',
    defaultMessage: 'Lockers',
  },
  mats: {
    id: 'venue-page.amenities.mats',
    defaultMessage: 'Mats',
  },
  parking: {
    id: 'venue-page.amenities.parking',
    defaultMessage: 'Parking',
  },
  publicTransportation: {
    id: 'venue-page.amenities.public-transportation',
    defaultMessage: 'Public Transportation',
  },
  showers: {
    id: 'venue-page.amenities.showers',
    defaultMessage: 'Showers',
  },
  toiletries: {
    id: 'venue-page.amenities.toiletries',
    defaultMessage: 'Toiletries',
  },
  towels: {
    id: 'venue-page.amenities.towels',
    defaultMessage: 'Towels',
  },
});

export const inclusivityMessages = defineMessages({
  title: {
    id: 'venue-page.inclusivity.title',
    defaultMessage: 'Business attributes',
  },
  explanation: {
    id: 'venue-page.inclusivity.explanation',
    defaultMessage: 'Let ClassPass members know more about your business.',
  },
  asianOwned: {
    id: 'venue-page.inclusivity.asianOwned',
    defaultMessage: 'Asian-owned',
  },
  blackOwned: {
    id: 'venue-page.inclusivity.blackOwned',
    defaultMessage: 'Black-owned',
  },
  hispanicLatinxOwned: {
    id: 'venue-page.inclusivity.hispanicLatinxOwned',
    defaultMessage: 'Hispanic/Latinx-owned',
  },
  indigenousOwned: {
    id: 'venue-page.inclusivity.indigenousOwned',
    defaultMessage: 'Indigenous-owned',
  },
  lgbtqFriendly: {
    id: 'venue-page.inclusivity.lgbtqFriendly',
    defaultMessage: 'LGBTQ-friendly',
  },
  lgbtqOwned: {
    id: 'venue-page.inclusivity.lgbtqOwned',
    defaultMessage: 'LGBTQ-owned',
  },
  veteranOwned: {
    id: 'venue-page.inclusivity.veteranOwned',
    defaultMessage: 'Veteran-owned',
  },
  wheelchairAccessible: {
    id: 'venue-page.inclusivity.wheelchairAccessible',
    defaultMessage: 'Wheelchair accessible',
  },
  womanOwned: {
    id: 'venue-page.inclusivity.womanOwned',
    defaultMessage: 'Woman-owned',
  },
});

export const sagaMessages = defineMessages({
  photosSuccess: {
    id: 'venue-page.saga.do-update-venue-page-photos.success',
    defaultMessage: 'You published a new photo to your page',
  },
  photosFailure: {
    id: 'venue-page.saga.do-update-venue-page-photos.failure',
    defaultMessage: 'We were unable to update your photo at this time',
  },
  additionalPhotoDeleteSuccess: {
    id: 'venue-page.saga.do-delete-additional-venue-photos.success',
    defaultMessage: 'You deleted a photo from your page',
  },
  additionalPhotoDeleteFailure: {
    id: 'venue-page.saga.do-delete-additional-venue-photos.failure',
    defaultMessage: 'We were unable to delete your photo at this time',
  },
  textSuccess: {
    id: 'venue-page.saga.do-update-venue-page-text.success',
    defaultMessage: 'Your changes have been saved',
  },
  textFailure: {
    id: 'venue-page.saga.do-update-venue-page-text.failure',
    defaultMessage: 'We were unable to update your content at this time',
  },
  requestFailure: {
    id: 'handle-route-enter.request.failure',
    defaultMessage: 'There was a problem with your request.',
  },
  reorderPhotosSuccess: {
    id: 'venue-page.saga.do-reorder-venue-page-photos.success',
    defaultMessage: 'You reordered additional photos from your page',
  },
  reorderPhotosFailure: {
    id: 'venue-page.saga.do-reorder-venue-page-photos.failure',
    defaultMessage: 'We were unable to reorder your photos at this time',
  },
  redirectFailure: {
    id: 'venue-page.saga.do-redirect-home.failure',
    defaultMessage: 'There was a problem redirecting you home.',
  },
});

export const photosMessages = {
  ...defineMessages({
    ariaLabelDeletePhoto: {
      id: 'venue-page.photos.delete-photo',
      defaultMessage: 'Delete photo',
    },
    ariaLabelPreviewPhoto: {
      id: 'venue-page.photos.preview-photo',
      defaultMessage: 'Preview photo',
    },
    cropOneDimension: {
      id: 'venue-page.photos.crop-one-dimension',
      defaultMessage: 'Minimum size must be <strong>{width} × {height} pixels</strong>.',
    },
    cropTwoDimensions: {
      id: 'venue-page.photos.crop-two-dimensions',
      defaultMessage: 'We’ll crop your photo to <strong>{width} pixels</strong> in width.',
    },
    publish: {
      id: 'venue-page.photos.publish',
      defaultMessage: 'Publish photo',
    },
  }),

  cropperModal: defineMessages({
    mobileHoriz: {
      id: 'venue-page.photos.cropper-modal.mobile-cover-photo',
      defaultMessage: 'Cover photo',
    },
    close: {
      id: 'venue-page.photos.cropper-modal.close',
      defaultMessage: 'Close modal',
    },
  }),

  photosIntro: defineMessages({
    title: {
      id: 'venue-page.photos.tip-title',
      defaultMessage: 'Showcase your venue',
    },
    description: {
      id: 'venue-page.photoss.tip-description',
      defaultMessage:
        'Businesses with <strong>great photos</strong> tend to get more reservations on ClassPass We recommend adding at least 3 or more authentic photos for your business. ',
    },
  }),

  coverPhoto: defineMessages({
    title: {
      id: 'venue-page.photos.cover-photo.section-title',
      defaultMessage: 'Add your cover photo',
    },
    alt: {
      id: 'venue-page.photos.cover-photo.image-alt',
      defaultMessage: 'Cover photo preview',
    },
    button: {
      id: 'venue-page.photos.cover-photo.button',
      defaultMessage: 'Upload photo',
    },
    explanationTitle: {
      id: 'venue-page.photos.cover-photo.explanation.title',
      defaultMessage: 'Cover photo',
    },
    explanationDescription: {
      id: 'venue-page.photos.cover-photo.explanation.description',
      defaultMessage: 'Your cover photo will show up on your page on the ClassPass mobile app and website.',
    },
    explanationAlt: {
      id: 'venue-page.photos.cover-photo.explanation.image-alt',
      defaultMessage: 'Cover photo example',
    },
  }),

  additionalPhotos: defineMessages({
    tag: {
      id: 'venue-page.photos.additional-photos.tag',
      defaultMessage: 'Recommended',
    },
    title: {
      id: 'venue-page.photos.additional-photos.section-title',
      defaultMessage: 'Add additional photos',
    },
    alt: {
      id: 'venue-page.photos.additional-photo.image-alt',
      defaultMessage: 'Photos preview',
    },
    button: {
      id: 'venue-page.photos.additional-photos.button',
      defaultMessage: 'Add more photos',
    },
    cropNote: {
      id: 'venue-page.photos.additional-photos.crop-note',
      defaultMessage:
        'Minimum sizes must be <strong>{width} × {height} pixels</strong>.{isDesktop, select, yes { You can reorder your photos by drag and drop.} other {}}',
    },
    explanationTitle: {
      id: 'venue-page.photos.additional-photos.explanation.title',
      defaultMessage: 'Photos',
    },
    explanationDescription: {
      id: 'venue-page.photos.additional-photos.explanation.description',
      defaultMessage:
        'Add more photos that highlight your facilities, classes, services, or amenities. These will help attract new customers.',
    },
    explanationAlt: {
      id: 'venue-page.photos.additional-photos.explanation.image-alt',
      defaultMessage: 'Photos example',
    },
  }),

  logo: defineMessages({
    title: {
      id: 'venue-page.photos.logo.section-title',
      defaultMessage: 'Add your logo',
    },
    alt: {
      id: 'venue-page.photos.logo.image-alt',
      defaultMessage: 'Logo preview',
    },
    button: {
      id: 'venue-page.photos.logo.button',
      defaultMessage: 'Upload photo',
    },
    explanationTitle: {
      id: 'venue-page.photos.logo.explanation.title',
      defaultMessage: 'Logo',
    },
    explanationDescription: {
      id: 'venue-page.photos.logo.explanation.description',
      defaultMessage: 'Your logo will show up on your page on the ClassPass website.',
    },
    explanationAlt: {
      id: 'venue-page.photos.logo.explanation.image-alt',
      defaultMessage: 'Logo example',
    },
  }),

  error: defineMessages({
    tooSmall: {
      id: 'venue-page.photos.error.too-small',
      defaultMessage:
        'Try a bigger photo; it must be at least {minWidth, number} pixels wide and {minHeight, number} pixels tall.',
    },
    logoTooSmall: {
      id: 'venue-page.photos.error.logo-too-small',
      defaultMessage: 'Your logo must be at least {minWidth, number} pixels in width.',
    },
    genericError: {
      id: 'venue-page.photos.error.generic-error',
      defaultMessage:
        'There was a problem uploading your photo. Please verify that your file is in GIF, JPEG, PNG or WEBP format, or try again later.',
    },
  }),
};

export const textMessages = defineMessages({
  descriptionTitle: {
    id: 'venue-page.text.description-title',
    defaultMessage: 'Description',
  },
  explanation: {
    id: 'venue-page.text.description-explanation',
    defaultMessage: 'Add details about your business to help members get to know more about your unique offerings.',
  },
  contactsTitle: {
    id: 'venue-page.text.contacts-title',
    defaultMessage: 'Contacts',
  },
  preparationTitle: {
    id: 'venue-page.text.preparation-title',
    defaultMessage: 'How to prepare',
  },
  preparationExplanation: {
    id: 'venue-page.text.preparation-explanation',
    defaultMessage:
      'Include what to bring, what to wear, and anything else a member should know. This information will be sent to members who make a reservation. ({MEDIUM_TEXT_MAX_CHARACTERS} characters)',
  },
  directionTitle: {
    id: 'venue-page.text.direction-title',
    defaultMessage: 'How to get there',
  },
  directionExplanation: {
    id: 'venue-page.text.direction-explanation',
    defaultMessage:
      'Add any notes to help members easily find your location. This information will be sent to members who make a reservation. ({MEDIUM_TEXT_MAX_CHARACTERS} characters)',
  },
  classScheduleDetailsTitle: {
    id: 'venue-page.text.class-schedule-details-title',
    defaultMessage: 'AutoSync schedule source',
  },
  classScheduleDetailsSubheader: {
    id: 'venue-page.text.class-schedule-details-subheader',
    defaultMessage: 'We’ll use your existing schedule to create your ClassPass schedule.',
  },
  classSchedulesEnableAutoSync: {
    id: 'venue-page.text.class-schedule-details-enable-autosync',
    defaultMessage:
      'AutoSync is currently disabled for this venue. <a>Contact us</a> to set up automatic schedule updates.',
  },
  classSchedulesDisableAutoSync: {
    id: 'venue-page.text.class-schedule-details-disable-autosync',
    defaultMessage: 'Prefer to manage your schedule yourself? <a>Contact us</a> to disable AutoSync.',
  },
  scheduleUrlLabel: {
    id: 'venue-page.text.schedule-url-label',
    defaultMessage: 'Provide a link to your studio’s schedule. ({limit, number} characters)',
  },
  scheduleUrlPlaceholder: {
    id: 'venue-page.text.schedule-url-placeholder',
    defaultMessage: 'For example the schedule page on your website',
  },
  charactersRemaining: {
    id: 'venue-page.text.characters-remaining',
    defaultMessage: '{remaining, plural, one {# character} other {# characters}} remaining',
  },
});

export const errorMessages = defineMessages({
  descriptionRequired: {
    id: 'venue-page-text.errors.description-required',
    defaultMessage: 'Description is required',
  },
  limitCharacters: {
    id: 'venue-page-text.errors.description-limit-characters',
    defaultMessage: 'Description is limited to {limit, number} characters',
  },
  websiteLimitCharacters: {
    id: 'venue-page-text.errors.website-limit-characters',
    defaultMessage: 'Website is limited to {limit, number} characters',
  },
  websiteUrlInvalid: {
    id: 'venue-page-text.errors.website-url-invalid',
    defaultMessage: 'Website link must be valid',
  },
  websiteUrlInvalidProtocol: {
    id: 'venue-page-text.errors.website-url-invalid-protocol',
    defaultMessage: 'Website address must start with http:// or https://',
  },
  preparationLimitCharacters: {
    id: 'venue-page-text.errors.preparation-limit-characters',
    defaultMessage: 'Preparation is limited to {limit, number} characters',
  },
  directionLimitCharacters: {
    id: 'venue-page-text.errors.direction-limit-characters',
    defaultMessage: 'Direction is limited to {limit, number} characters',
  },
  facebookInvalid: {
    id: 'venue-page-text.errors.facebook-invalid',
    defaultMessage: 'Facebook URL must be valid',
  },
  twitterInvalid: {
    id: 'venue-page-text.errors.twitter-invalid',
    defaultMessage: 'Twitter handle must be valid',
  },
  instagramInvalid: {
    id: 'venue-page-text.errors.instagram-invalid',
    defaultMessage: 'Instagram handle must be valid',
  },
  scheduleUrlInvalid: {
    id: 'venue-page-text.errors.schedule-url-invalid',
    defaultMessage:
      'Session schedule link must include the full URL. Please check that the link provided includes http:// or https://.',
  },
  phoneNumberInvalid: {
    id: 'venue-page-text.errors.phone-number-invalid',
    defaultMessage: 'Phone number must be numeric',
  },
});

export const contactsMessages = defineMessages({
  facebookPlaceholder: {
    id: 'venue-page.contacts.facebook-placeholder',
    defaultMessage: 'Facebook URL',
  },
  twitterPlaceholder: {
    id: 'venue-page.contacts.twitter-placeholder',
    defaultMessage: 'twitter',
  },
  instagramPlaceholder: {
    id: 'venue-page.contacts.instagram-placeholder',
    defaultMessage: 'instagram',
  },
  websitePlaceholder: {
    id: 'venue-page.contacts.website-placeholder',
    defaultMessage: 'Website URL',
  },
  phonePlaceholder: {
    id: 'venue-page.contacts.phone-placeholder',
    defaultMessage: 'Phone number',
  },
});

export const navMessages = defineMessages({
  title: {
    id: 'venue-page.nav.title',
    defaultMessage: '{venueName}{venueSubtitle, select, undefined {} other { ({venueSubtitle})}}',
  },
  profile: {
    id: 'venue-page.nav.profile',
    defaultMessage: 'Profile',
  },
  settings: {
    id: 'venue-page.nav.settings',
    defaultMessage: 'Settings',
  },
  autoSync: {
    id: 'venue-page.nav.auto-sync',
    defaultMessage: 'AutoSync',
  },
  waivers: {
    id: 'venue-page.nav.waivers',
    defaultMessage: 'Waivers',
  },
  publish: {
    id: 'venue-page.nav.publish',
    defaultMessage: 'Save',
  },
  updateError: {
    id: 'venue-page.nav.update-error',
    defaultMessage: 'There was a problem updating your studio’s details. Please check the form for errors.',
  },
});

export const reservableMinutesBeforeMessages = defineMessages({
  title: {
    id: 'venue-page.reservable-minutes-before.title',
    defaultMessage: 'Reservation deadline',
  },
  description: {
    id: 'venue-page.reservable-minutes-before.description',
    defaultMessage: 'Set a deadline for when ClassPass members need to make reservations prior to start time.',
  },
  dropdown: {
    id: 'venue-page.reservable-minutes-before.dropdown',
    defaultMessage: '<dropdown>5 minutes</dropdown> prior to start time',
  },
  dropdownItem: {
    id: 'venue-page.reservable-minutes-before.dropdown-item',
    defaultMessage:
      '{hours, select, 0 {} other {{hours, plural, one {{hours} hour} other {{hours} hours}}  }}{minutes, select, 0 {} other {{minutes} min}}',
  },
});

export const venueAutoSyncMessages = defineMessages({
  autoSync: {
    id: 'venue-page.auto-sync.auto-sync',
    defaultMessage: 'AutoSync',
  },
  on: {
    id: 'venue-page.auto-sync.on',
    defaultMessage: 'On',
  },
  off: {
    id: 'venue-page.auto-sync.off',
    defaultMessage: 'Off',
  },
});

export const venueWaiversMessages = defineMessages({
  enableSuccess: {
    id: 'venue-page.waivers.enabled',
    defaultMessage: 'The waiver for {venueName} has been enabled successfully',
  },
  disableSuccess: {
    id: 'venue-page.waivers.disabled',
    defaultMessage: 'The waiver for {venueName} has been disabled successfully',
  },
  toggleError: {
    id: 'venue-page.waivers.toggle-error',
    defaultMessage:
      'An error occured while attempting to toggle the status of the waiver for {venueName}. Please try again later.',
  },
});

export const videosMessages = {
  ...defineMessages({
    title: {
      id: 'venue-page.details.videos.title',
      defaultMessage: 'Embed videos',
    },
    description: {
      id: 'venue-page.details.videos.description',
      defaultMessage: 'Add videos to help ClassPass members to learn more about your business.',
    },
    addItem: {
      id: 'venue-page.details.videos.add-item',
      defaultMessage: '{plusIcon} Add video',
    },
    deleteItem: {
      id: 'venue-page.details.videos.delete-item',
      defaultMessage: 'Delete',
    },
    refreshItem: {
      id: 'venue-page.details.videos.refresh-item',
      defaultMessage: 'Refresh',
    },
    platformIdPlaceholder: {
      id: 'venue-page.details.videos.platform-id-placeholder',
      defaultMessage: 'Paste video URL',
    },
    fetchError: {
      id: 'venue-page.details.videos.fetch-error',
      defaultMessage: 'Unable to retrieve video information from YouTube. Please try again later.',
    },
    platformIdError: {
      id: 'venue-page.details.videos.platform-id-error',
      defaultMessage: 'Invalid video URL',
    },
    platformIdErrorDuplicate: {
      id: 'venue-page.details.videos.platform-id-error-duplicate',
      defaultMessage: 'Video already in list',
    },
    categoryPlaceholder: {
      id: 'venue-page.details.videos.category-placeholder',
      defaultMessage: 'Select a category',
    },
  }),
  category: defineMessages({
    facilitiesAndAmenities: {
      id: 'venue-page.details.videos.category.facilities-and-amenities',
      defaultMessage: 'Facilities & Amenities',
    },
    generalInformation: {
      id: 'venue-page.details.videos.category.general-nformation',
      defaultMessage: 'General Information',
    },
    instructors: {
      id: 'venue-page.details.videos.category.instructors',
      defaultMessage: 'Staff',
    },
    newsCoverage: {
      id: 'venue-page.details.videos.category.news-coverage',
      defaultMessage: 'News Coverage',
    },
    safetyAndCleanliness: {
      id: 'venue-page.details.videos.category.safety-and-cleanliness',
      defaultMessage: 'Safety & Cleanliness',
    },
  }),
};
